<template>
  <section class="container">
    <el-carousel :interval="4000" indicator-position="outside" height="112px">
        <el-carousel-item class="banner">
          <img class="banner-img" :src="banner1">
        </el-carousel-item>
        <div class="headerFontRecuit">
          <span class="headerFontRecuitOne">魅力城轨 &nbsp;  美丽徐州</span>
        </div>
      </el-carousel>
     <div class="pathInfo">当前位置：人才招聘 > 岗位详情 > 申请职位</div>
    <div class="resume-success-bg" :style="{'min-height': bgHeight, 'backgroundImage': 'url(' + img3 + ')'}">
      <div class="content">
        <img :src="error">
        <span>{{ message }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import error from 'assets/PC/toudishibai_icon_tdsb.png'
import Banner1 from 'assets/PC/banner_zpxqy.png'
import img3 from 'assets/PC/bg_zpxqy.png'
export default {
  data: () => {
    return {
      bgHeight:'550px',
      img3:img3,
      banner1: Banner1,
      error,
      message: '感谢您对徐州地铁的关注， 您不符合该岗位的投递条件，谢谢。'
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        let he = document.body.clientHeight - 65 - 270
        if(he<550){
          he = 550
        }
        this.bgHeight = he + 'px'
        this.bgHeightContent = (he - 10) + 'px'
      })()
    }
  },
  created() {
     let msg =  this.$route.params.msg;
     console.log(msg);
     if(msg === '本次招聘活动您已成功投递过简历。'){
        this.message = msg;
     } else {
        this.message = '感谢您对徐州地铁的关注， 您不符合该岗位的投递条件，谢谢。';
     }

   },
  methods:{
    initHeight() {
      let he = document.body.clientHeight - 245
      if(he<550){
        he = 550
      }
      this.bgHeight = he + 'px'
      this.bgHeightContent = (he - 10) + 'px'
    }
  }
}
</script>

<style scoped>
  .pathInfo{
    font-size: 12px;
    border-bottom: #eeeeee solid 1px;
    height: 1.8rem;
    width: 65%;
    margin: 20px auto 0;
  }
  .footer-wrapper{
    margin-top: 0;
  }
  .resume-success-bg {
    padding-top: 20px;
  }
  .banner-img{
    width: 100%;
  }
  .headerFontRecuit {
    position: absolute;
    left: 68%;
    z-index: 99;
    top: 28%;
    color: white;
    text-align: center
  }
  .headerFontRecuitOne {
    margin-bottom: 20px;
    display: inline-block;
    font-size: 1.6em;
  }
  .resume-success-bg .content{
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/resume/error.vue